import { render, staticRenderFns } from "./colLinea.vue?vue&type=template&id=2467e2c3&"
import script from "./colLinea.vue?vue&type=script&lang=js&"
export * from "./colLinea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports